// themeHandler.ts
export const themeProperties = {
  primary: {
    modalBackgroundColor: "#fff",
    closeButtonColor: "#7f7f7f",
    contentTextColor: "#000",
    buttonBackgroundColor: "rgb(219 41 46)",
    buttonTextColor: "#fff",
    buttonTextHoverColor: "#000",
    footerTextColor: "#000",
    footerTextHoverColor: "#000000bd",
    borderColor: "rgb(219 41 46)",
  },
  secondary: {
    modalBackgroundColor: "#68002D",
    closeButtonColor: "#fff",
    contentTextColor: "#fff",
    buttonBackgroundColor: "#fff",
    buttonTextColor: "#000",
    buttonTextHoverColor: "#000",
    footerTextColor: "#9DC3E6",
    footerTextHoverColor: "#9dd6e6",
    borderColor: "#fff",
  },
  powerUps: {
    modalBackgroundColor: "#fff",
    closeButtonColor: "#7f7f7f",
    contentTextColor: "#000",
    buttonBackgroundColor: "#873852",
    buttonTextColor: "#fff",
    buttonTextHoverColor: "#fff",
    footerTextColor: "#873852",
    footerTextHoverColor: "#000",
    borderColor: "#873852",
  },
};

export const getColor = (theme: string, property: string) => {
  return themeProperties[theme]
    ? themeProperties[theme][property]
    : themeProperties.primary[property];
};
